module.exports = __webpack_public_path__ + "static/MOMO2-b9b954eba100a2f7741885339b34067a.jpg";